/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TagType {
    COMPOSITE = 'composite',
    COMPANY_JOB = 'companyJob',
}
